import { createSelector } from 'reselect';
import {
  getFreeBetAmountsUtil,
  getSelectedFreeBetAmountUtil
} from 'utils/betslip/freeBetHelpers';
import { getSelectorRoot } from 'utils/selectors';
import { EBetslipType } from 'interfaces/betslip';
import { GENERAL_FIELD_KEY } from 'newelements/_Betslip/utils/constants/shared';
import {
  getBetslipType,
  getComputedBetType
} from 'store/selectors/betslip/configs';

const getBetSlip = getSelectorRoot('betSlip');

// Free bet
const getFreeBets = getBetSlip('freeBets');

const getIsFreeBetEnabled = createSelector(
  [getFreeBets],
  ({ selectedFreeBetEventId }) => !!selectedFreeBetEventId
);

const getSelectedFreeBetEventId = createSelector(
  [getFreeBets],
  freeBets => freeBets.selectedFreeBetEventId
);

const getFreeBetAmounts = createSelector(
  [getBetslipType, getComputedBetType, getFreeBets],
  getFreeBetAmountsUtil
);

const getSelectedFreeBetAmount = createSelector(
  [getFreeBetAmounts, getFreeBets],
  getSelectedFreeBetAmountUtil
);

const getSingleEventFreeBetAmounts = (eventId: string | number) =>
  createSelector([getFreeBets], freeBetsStore => {
    return freeBetsStore.singleEventFreeBets[eventId];
  });

const getFreeBetsByEventId = (eventId: string | number) =>
  createSelector(
    [getFreeBets, getBetslipType],
    (freeBetsStore, betslipType) => {
      if (eventId) {
        if (eventId !== GENERAL_FIELD_KEY) {
          return freeBetsStore.singleEventFreeBets[eventId] || [];
        } else {
          if (betslipType === EBetslipType.BASIC) {
            return freeBetsStore.multipleFreeBets || [];
          }

          return freeBetsStore.advancedFreeBets || [];
        }
      }

      return [];
    }
  );

const getSelectedFreeBetData = createSelector(
  [getFreeBets, getFreeBetAmounts],
  (freeBetsStore, amounts) =>
    freeBetsStore.selectedFreeBetId &&
    amounts?.find(item => item.value === freeBetsStore.selectedFreeBetId)
);

const getIsFrenchFreeBetEnabled = getBetSlip('isFrenchFreeBetEnabled');

const getIsSingleEventFreeBetEnabled = (eventId?: string | number) =>
  createSelector([getSelectedFreeBetEventId], selectedFreeBetEventId =>
    eventId ? eventId === selectedFreeBetEventId : false
  );

export {
  getFreeBets,
  getFreeBetAmounts,
  getFreeBetsByEventId,
  getIsFreeBetEnabled,
  getSelectedFreeBetData,
  getSelectedFreeBetAmount,
  getSelectedFreeBetEventId,
  getIsFrenchFreeBetEnabled,
  getSingleEventFreeBetAmounts,
  getIsSingleEventFreeBetEnabled
};
